// src/services/datosMaestrosService.js
import apiClient from './apiClient';

const DatosMaestrosService = {
    // ===== TRIBUNALES =====
    getTribunales: () => apiClient.get('/datos-maestros/tribunales'),
    getTribunalById: (id) => apiClient.get(`/datos-maestros/tribunales/${id}`),
    createTribunal: (data) => apiClient.post('/datos-maestros/tribunales', data),
    updateTribunal: (id, data) => apiClient.put(`/datos-maestros/tribunales/${id}`, data),
    deleteTribunal: (id) => apiClient.delete(`/datos-maestros/tribunales/${id}`),

    // ===== ABOGADOS =====
    getAbogados: () => apiClient.get('/datos-maestros/abogados'),
    getAbogadoById: (id) => apiClient.get(`/datos-maestros/abogados/${id}`),
    createAbogado: (data) => apiClient.post('/datos-maestros/abogados', data),
    updateAbogado: (id, data) => apiClient.put(`/datos-maestros/abogados/${id}`, data),
    deleteAbogado: (id) => apiClient.delete(`/datos-maestros/abogados/${id}`),

    // ===== CONSULTORIOS =====
    getConsultorios: () => apiClient.get('/datos-maestros/consultorios'),
    getConsultorioById: (id) => apiClient.get(`/datos-maestros/consultorios/${id}`),
    createConsultorio: (data) => apiClient.post('/datos-maestros/consultorios', data),
    updateConsultorio: (id, data) => apiClient.put(`/datos-maestros/consultorios/${id}`, data),
    deleteConsultorio: (id) => apiClient.delete(`/datos-maestros/consultorios/${id}`),

    // ===== LUGARES =====
    getLugares: () => apiClient.get('/datos-maestros/lugares'),
    getLugarById: (id) => apiClient.get(`/datos-maestros/lugares/${id}`),
    createLugar: (data) => apiClient.post('/datos-maestros/lugares', data),
    updateLugar: (id, data) => apiClient.put(`/datos-maestros/lugares/${id}`, data),
    deleteLugar: (id) => apiClient.delete(`/datos-maestros/lugares/${id}`),

    // ===== REFERENCIAS =====
    getReferencias: () => apiClient.get('/datos-maestros/referencias'),
    getReferenciaById: (id) => apiClient.get(`/datos-maestros/referencias/${id}`),
    createReferencia: (data) => apiClient.post('/datos-maestros/referencias', data),
    updateReferencia: (id, data) => apiClient.put(`/datos-maestros/referencias/${id}`, data),
    deleteReferencia: (id) => apiClient.delete(`/datos-maestros/referencias/${id}`),
    sincronizarReferenciasDesdeUsuarios: () => apiClient.post('/datos-maestros/referencias/sincronizar-usuarios'),
    fusionarReferencias: (idsOrigen, idDestino) => apiClient.post('/datos-maestros/referencias/fusionar', { idsOrigen, idDestino }),

    // ===== MOTIVOS DE RECHAZO =====
    getMotivosRechazo: () => apiClient.get('/datos-maestros/motivos-rechazo'),
    createMotivoRechazo: (data) => apiClient.post('/datos-maestros/motivos-rechazo', data),
    updateMotivoRechazo: (id, data) => apiClient.put(`/datos-maestros/motivos-rechazo/${id}`, data),
    deleteMotivoRechazo: (id) => apiClient.delete(`/datos-maestros/motivos-rechazo/${id}`),

    // ===== RESULTADOS DE LA ATENCIÓN =====
    // Mismo criterio que los motivos de rechazo: el nombre de la fila es el valor que se
    // guarda en el turno (ver migración V224).
    getResultadosAtencion: () => apiClient.get('/datos-maestros/resultados-atencion'),
    createResultadoAtencion: (data) => apiClient.post('/datos-maestros/resultados-atencion', data),
    updateResultadoAtencion: (id, data) => apiClient.put(`/datos-maestros/resultados-atencion/${id}`, data),
    deleteResultadoAtencion: (id) => apiClient.delete(`/datos-maestros/resultados-atencion/${id}`),

    // ===== CARPETAS =====
    // Carpetas físicas del archivo del estudio. soloActivas=true lo usa el selector de la ficha
    // del trámite; el ABM lista todo para poder reactivar.
    getCarpetas: (soloActivas = false) => apiClient.get(`/datos-maestros/carpetas?soloActivas=${soloActivas}`),
    createCarpeta: (data) => apiClient.post('/datos-maestros/carpetas', data),
    updateCarpeta: (id, data) => apiClient.put(`/datos-maestros/carpetas/${id}`, data),
    reordenarCarpetas: (idsEnOrden) => apiClient.put('/datos-maestros/carpetas/reordenar', { idsEnOrden }),
    deleteCarpeta: (id) => apiClient.delete(`/datos-maestros/carpetas/${id}`),

    // ===== REGÍMENES DIFERENCIALES =====
    getRegimenesDiferenciales: (soloActivos = false) => apiClient.get(`/datos-maestros/regimenes-diferenciales?soloActivos=${soloActivos}`),
    createRegimenDiferencial: (data) => apiClient.post('/datos-maestros/regimenes-diferenciales', data),
    updateRegimenDiferencial: (id, data) => apiClient.put(`/datos-maestros/regimenes-diferenciales/${id}`, data),
    deleteRegimenDiferencial: (id) => apiClient.delete(`/datos-maestros/regimenes-diferenciales/${id}`),

    // ===== REGÍMENES DEL TRÁMITE DE JUBILACIÓN =====
    // No confundir con los de arriba (calculadora de aportes): estos son las opciones del
    // desplegable "Régimen diferencial" del trámite y su documentación.
    getRegimenesJubilacion: (soloActivos = false) => apiClient.get(`/datos-maestros/regimenes-jubilacion?soloActivos=${soloActivos}`),
    getDocumentacionBaseRegimenJubilacion: () => apiClient.get('/datos-maestros/regimenes-jubilacion/documentacion-base'),
    createRegimenJubilacion: (data) => apiClient.post('/datos-maestros/regimenes-jubilacion', data),
    updateRegimenJubilacion: (id, data) => apiClient.put(`/datos-maestros/regimenes-jubilacion/${id}`, data),
    updateDocumentacionRegimenJubilacion: (id, data) => apiClient.put(`/datos-maestros/regimenes-jubilacion/${id}/documentacion`, data),
    deleteRegimenJubilacion: (id) => apiClient.delete(`/datos-maestros/regimenes-jubilacion/${id}`)
};

export default DatosMaestrosService;
